import i18n from '@/i18n'

i18n.mergeLocaleMessage('en', {
	'dashboard' : {
        'name': 'Home',
        'buttons': {
            'later': 'Later',
            'start_optimize': 'Start optimize',
            'done': 'Done',
            'explore_now': 'Explore now',
            'got_it': 'Got it'
        },
        'component': {
            'optimize_theme': 'Theme Optimization',
            'optimize_theme_description': 'We minify code, lazyload image, extract critical CSS ... to boost your theme performance',
            'optimize_image': 'Image Optimization',
            'optimize_image_description': 'We use smart lossy compression to reduce your image sizes while retaining excellent visual quality',
            'optimize_actual_speed': 'Optimize Actual Speed',
            'actual_speed_description': 'Actual Speed is how fast your pages load. Optimize images and theme to<br>boost Actual Speed. '
        },
        'blogs': {
            'name': 'Blog',
            'blog_1': 'Understanding Smart Preloading and how top companies uses it to speed up their sites',
            'blog_2': 'Improving your online store speed',
            'blog_3': 'How is the price of Swift Expert Service in comparison to other speed services\' price?',
            'blog_4': 'Why speed score on Google PageSpeed Insight important?',
            'blog_5': '10 Ways How to Optimize Images for the Web for SEO',
            'blog_6': 'How to Refactor a Shopify Site for Javascript Performance'
        },
        'new': {
            'name': 'What’s new',
            'new_1': 'SWIFT EXPERT',
            'new_2': 'Speed Optimization',
            'new_3': 'customized by our Experts ',
            'btn': 'View Swift Expert service',
            'new_offer_title': 'What we commit?',
            'new_offer_1': 'Higher score',
            'new_offer_2': 'Faster site',
            'new_offer_3': 'Instant result'
        },
        'quick_actions': {
            'name': 'Quick actions',
            'status': {
                'inactive': 'Inactive',
                'active': 'Active',
                'new': 'New',
                'view': 'New',
                'optimized': 'Optimized',
                'optimize': 'Need optimization',
                'optimizing': 'Optimizing',
            },
            'optimize': {
                'title': 'Optimize Actual Speed',
                'buttons': {
                    'optimize': 'Optimize now',
                    'optimized': 'View details'
                }
            },
            'preloading': {
                'title': 'Set Up Preloading',
                'inactive': 'Active to boost loading speed <strong>up to 900ms</strong>.',
                'active': 'Active to boost loading speed <strong>up to 900ms</strong>.',
                'buttons': {
                    'inactive': 'Active now',
                    'active': 'Customize'
                }
            },
            'loading_screen': {
                'title': 'Set Up Loading Screen',
                'inactive': 'Active to enhance customer’s experience and boost brand.',
                'active': 'Active to enhance customer’s experience and boost brand.',
                'buttons': {
                    'inactive': 'Active now',
                    'active': 'Customize'
                }
            },
            'swift_expert': {
                'title': 'Swift Expert',
                'inactive': 'Customized speed optimization by<br>our dedicated expert.',
                'active': 'Customized speed optimization by<br>our dedicated expert.',
                'new': 'Customized speed optimization by<br>our dedicated expert.',
                'view': 'Customized speed optimization by<br>our dedicated expert.',
                'buttons': {
                    'new': 'Try Now',
                    'view': 'View my ticket',
                    'inactive': 'Active now',
                    'active': 'Customize'
                }
            },
        },
        'box_try_perceived_speed': {
            'title': "Try perceived speed. It's FREE",
            'content': 'Boost user perception of speed with preloading and loading screen. Try without any cost in <strong>14 days</strong>.',
            'btn_text': 'Explore',
            'title_upgrade': 'Perceived performance matters',
            'content_upgrade': 'Unlock Premium Speed to boost user perception of speed with Preloading and Loading Screen',
            'btn_select': 'Upgrade plan'
        },
        'box_upgrade': {
            'title': "Your store can be faster",
            'content': 'Continue to save <strong>{size}</strong> with Premium Speed by optimizing image and theme.',
            'btn_text': 'Upgrade plan'
        },
        'upgrade_success': {
            'premium': {
                'title': "You're using Premium plan",
                'description': 'Fasten your seatbelt. Your store speed is about to be faster than ever.',
                'endTrial': {
                    'title': 'Premium Speed has been subscribed!',
                    'description': '<strong>1000 free images</strong> has been added. Enjoy the best of<br>Swift and boost your store speed.',
                }
            },
            'free': {
                'title': "You're on Free plan",
                'description': 'You can continue using Preloading.<br>Upgrade to Premium plan anytime for full features.',
            },
            'old-plan': {
                'title': "Heads up! You're now on Premium plan",
                'description': "Thanks for being with us. We've upgraded your plan to Premium with <strong>no extra charge</strong>."
            }
        },
        "store_credibility": {
            "credibility": "Credibility",
            "explore_alireview": "Explore Ali Reviews",
            "open_app": "Open app",
            "view_demo_store": "View demo store",
            "not_install": {
                "title": "Grow your store with innovative solutions",
                "line": "Your social roof ranking is quite low, which will cause:",
                "line_1": "Conversion reduced by 50% due to lacking of reviews",
                "line_2": "70% social leads unconverted for poor sharing reviews",
                "line_3": "40% post-purchase reviews loss for weak request tools",
                "des": "Let Ali Reviews help you boost your store reputation!"
            },
            "install_yotpo": {
                "title": "Reinforce your trustworthy store with social proof",
                "line": "Your social roof ranking is quite low, which will causes:",
                "line_1": "78% target users dropped for no personalizing reviews",
                "line_2": "70% social leads unconverted for poor sharing reviews ",
                "line_3": "40% post-purchase reviews loss for weak request tools",
                "des": "Let Ali Reviews help improve and boost your store!"
            },
            "install_loox": {
                "title": "Stunning review widgets make revenue higher by 80%",
                "line": "Your store’s performance must improve or else it suffers:",
                "line_1": "Monthly post-purchase reviews loss for limted emails",
                "line_2": "Target audience dropped by 80% basic widget settings",
                "line_3": "70% conversion failed for unattractive review widgets",
                "des": "What are you waiting for? Try innovative solution now!"
            },
            "install_judgeme": {
                "title": "Personalized review widget can increase 70% revenue",
                "line": "Your store’s success must improve or else it can cause:",
                "line_1": "78% target users dropped for no personalizing reviews",
                "line_2": "40% post-purchase reviews loss for weak request tools",
                "line_3": "70% email review request failed due to poor open rate",
                "des": "Get the innovative solution to improve your store now!"
            },
            "install_fera": {
                "title": "Grow quickly with monthly 500 customers",
                "line": "Your store liability must enhance or be left behind for:",
                "line_1": "Credibility loss by 70% for poor auto request tools",
                "line_2": "80% conversion failed for no personalizing audience",
                "line_3": "40% revenue fell due to unattractive review widgets",
                "des": "Get the innovative solution to improve your store now!"
            },
            "install_automizely": {
                "title": "Strengthen store branding with better features",
                "line": "Is your product review solution prevent you from:",
                "line_1": "Credibility loss by 70% for poor auto request tools",
                "line_2": "10K leads lost/month for poor sharing reviews",
                "line_3": "40% revenue fell due to unattractive review widgets",
                "des": "Ali Reviews is here to assist you, view our suggestions!"
            },
            "install_alireview": {
                "title": "Your store’s on the right track now!",
                "line": "Keep growing your store with our dedicated service!",
                "line_1": "Personalized reviews improve monthly revenue by 50%",
                "line_2": "Stunning widgets raises conversion rate by 70%",
                "line_3": "Visual sharing review boosts social leads by 80%"
            },
            "install_multiple": {
                "title": "It’s not just a product review app but a solution",
                "line": "Your store isn’t equipped good solutions, this can lead:",
                "line_1": "78% target audience dropped due to poor reviews",
                "line_2": "40% revenue fell due to unattractive review widgets",
                "line_3": "70% email review request failed due to poor open rate",
                "des": "Ali Reviews is here to assist you, view our suggestions!"
            }
        },
        "store_evaluation": {
            "title": "Store evaluation",
            "des": "Here is some evaluation about your store, keep it near 100 to maximize your store performance.",
            "re_evaluate": "Re-evaluate",
        },
        "store_speed": {
            "speed_0_19": {
                "title": "Your store is slower than 90% similar stores",
                "des": "Your site's speed is extremely slow, which can lead to:",
                "btn": "Fix speed issue with expert",
                "order_100": {
                    "line_1": "11% fewer page views",
                    "line_2": "6-10 orders monthly loss",
                    "line_3": "Make store less discoverable"
                },
                "order_300": {
                    "line_1": "11% fewer page views",
                    "line_2": "15-30 orders monthly loss",
                    "line_3": "Decrease search engine rankings"
                },
                "order_500": {
                    "line_1": "7% loss in conversions",
                    "line_2": "3% increase in bounce rate",
                    "line_3": "Decrease search engine rankings"
                },
                "order_1000": {
                    "line_1": "11% fewer page views",
                    "line_2": "17% decrease in conversion rate",
                    "line_3": "Negative impact on your brand's trust and loyalty"
                },
                "order_more_1000": {
                    "line_1": "Decrease 40% mobile conversion rates",
                    "line_2": "3% increase in bounce rate",
                    "line_3": "Make store less discoverable"
                }
            },
            "speed_20_39": {
                "title": "Your store is slower than 60% similar stores",
                "des": "Improving your store speed by one second can avoid:",
                "btn": "Maximize speed with expert",
                "order_100": {
                    "line_1": "11% fewer page views",
                    "line_2": "16% decrease in customer satisfaction",
                    "line_3": "6-10 orders monthly loss"
                },
                "order_300": {
                    "line_1": "11% fewer page views",
                    "line_2": "3% increase in bounce rate",
                    "line_3": "15-30 orders monthly loss"
                },
                "order_500": {
                    "line_1": "7% loss in conversions",
                    "line_2": "3% increase in bounce rate",
                    "line_3": "Decrease search engine rankings"
                },
                "order_1000": {
                    "line_1": "11% fewer page views",
                    "line_2": "17% decrease in conversion rate",
                    "line_3": "Negative impact on your brand's trust and loyalty"
                },
                "order_more_1000": {
                    "line_1": "Decrease 40% mobile conversion rates",
                    "line_2": "15% decrease in revenue",
                    "line_3": "Negative impact on your brand's trust and loyalty"
                }
            },
            "speed_40_60": {
                "title": "Your store is faster than 60% similar stores",
                "des": "Speed is now a powerful and effective tool for you to:",
                "fa_experts": "FireApps Experts is ready to help at any time.",
                "btn": "Chat with us",
                "order_100": {
                    "line_1": "Decrease bounce rate",
                    "line_2": "Increase Google SEO rankings"
                },
                "order_300": {
                    "line_1": "Increase Google SEO rankings",
                    "line_2": "Improve customer buying experience"
                },
                "order_500": {
                    "line_1": "Increase Google SEO rankings",
                    "line_2": "Decrease bounce rate"
                },
                "order_1000": {
                    "line_1": "Increase Google SEO rankings",
                    "line_2": "Build your brand's trust and loyalty"
                },
                "order_more_1000": {
                    "line_1": "Improve customer buying experience",
                    "line_2": "Build your brand's trust and loyalty"
                }
            },
            "speed_61_100": {
                "title": "Your store is faster than 90% similar stores",
                "des": "Great. By keeping this oustanding speed score, <br>your store is on the way to success, helping you to:",
                "order_100": {
                    "line_1": "Improve customer buying experience",
                    "line_2": "Increase Google SEO rankings",
                    "line_3": "Build your brand's trust and loyalty"
                },
                "order_300": {
                    "line_1": "Improve customer buying experience",
                    "line_2": "Increase Google SEO rankings",
                    "line_3": "Build your brand's trust and loyalty"
                },
                "order_500": {
                    "line_1": "Improve customer buying experience",
                    "line_2": "Increase Google SEO rankings",
                    "line_3": "Build your brand's trust and loyalty"
                },
                "order_1000": {
                    "line_1": "Improve customer buying experience",
                    "line_2": "Increase Google SEO rankings",
                    "line_3": "Build your brand's trust and loyalty"
                },
                "order_more_1000": {
                    "line_1": "Improve customer buying experience",
                    "line_2": "Increase Google SEO rankings",
                    "line_3": "Build your brand's trust and loyalty"
                }
            }
        },
    }
})